export function formatAuthError(err: unknown): string {
  const code = (err as any)?.code as string | undefined;
  switch (code) {
    case 'auth/invalid-email': return 'Invalid email address.';
    case 'auth/user-disabled': return 'This account has been disabled.';
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential': return 'Incorrect email or password.';
    case 'auth/email-already-in-use': return 'An account with this email already exists.';
    case 'auth/weak-password': return 'Password must be at least 6 characters.';
    case 'auth/too-many-requests': return 'Too many attempts. Please wait and try again.';
    case 'auth/network-request-failed': return 'Network error. Check your connection.';
    case 'auth/popup-closed-by-user': return 'Sign-in popup was closed.';
    case 'auth/popup-blocked': return 'Pop-up blocked by your browser. Allow pop-ups and try again.';
    default:
      if (code?.startsWith('auth/')) return 'Authentication failed. Please try again.';
      return (err as any)?.message || 'An unexpected error occurred.';
  }
}

/* Firestore-side failures while looking up or applying a pending invite. Kept separate
   from "no invite exists", which is the normal state for anyone who already belongs to an
   org — conflating the two is what made a wrong-address sign-in look like a no-op. */
export function formatInviteError(err: unknown): string {
  const code = (err as any)?.code as string | undefined;
  switch (code) {
    case 'permission-denied':
      return 'We could not check for an invitation for this address — the request was denied.';
    case 'unavailable':
    case 'deadline-exceeded':
      return 'We could not reach the server to check for your invitation. Check your connection and try again.';
    default:
      return (err as any)?.message || 'We could not check for an invitation for this address.';
  }
}
